// extracted by mini-css-extract-plugin
module.exports = {"overlay-z-index":"10001","buffer-size":"30px","hover-popover":"hover-popover__hover-popover___Uw_nB","hover-buffer":"hover-popover__hover-buffer___c2gbz"};